import {StoreType} from '../../../types/sharedTypes';

export const plannerParamsSelector = (state: StoreType) => {
  return state.plannerReducer.params;
}

export const allPlannerSelector = (state: StoreType) => {
  return state.plannerReducer.planner;
}
